<template>
  <div class="noticedetail">
    <Breadcrumb separator=">">
      <BreadcrumbItem to="/message/notice">{{$t('title.w38')}}</BreadcrumbItem>
      <BreadcrumbItem>{{$t('title.w39')}}</BreadcrumbItem>
    </Breadcrumb>
    <div class="notice-content">
      <h3 class="h3">{{title}}</h3>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      title: ""
    };
  },
  created() {
    this.$axios
      .get("/Member/RZJInfoCenter/NewDetail", {
        params: {
          newId: this.$route.query.id
        }
      })
      .then(res => {
        console.log(res);
        if (res.err) {
          res.throw();
          this.$router.replace({ name: "notice" });
          return;
        }
        this.content = res.Content;
        this.title = res.Subject;
      });
  }
};
</script>

<style lang="less" scoped>
.noticedetail {
  width: 1200px;
  min-height: 600px;
  .notice-content {
    width: 800px;
    margin: 0 auto;
    color: #232325;
    .mar-r30 {
      margin-right: 30px;
    }
    .h3 {
      font-size: 24px;
      font-weight: 500;
      margin: 40px 0 50px;
      text-align: center;
    }
  }
}
</style>
